import type {CampaignSurfaceId} from "analytics/landingVisit";
import type {CampaignCopy} from "i18n/en/campaign";
import {isHalloweenEdition, type CampaignId} from "./campaignPlayback";

/**
 * What one edition's copy plate says (React-free). An offer edition reads `campaign.editions` under the offered
 * plan's name and opens the plans; the Halloween slide (kitecorp/transferify-ui#3776) sells no plan, so its
 * eyebrow is its own name and its button opens the file chooser on the landing. On the recipient page that
 * button goes to the landing instead, so it says so, in the guests' words the owner approved on 2026-10-26: a
 * "Select your files" there sat beside the file list's own "Select <file>" buttons, which a recipient hears as
 * one more of them and two specs counted as one (`selected-zip`, `selected-zip-owner`).
 */
export interface CampaignPlate {
	label: string;
	title: string;
	copy: string;
	/** The button's words. */
	action: string;
	/** Empty when the edition has none. */
	note: string;
	caption: string;
	/** The word on the cursor badge over the artwork. */
	badge: string;
}

export function campaignPlate(campaign: CampaignCopy, id: CampaignId, monthlyPrice: string, surface: CampaignSurfaceId): CampaignPlate {
	const edition = campaign.editions[id];
	const seasonal = isHalloweenEdition(id);
	return {
		label: seasonal ? edition.badge : campaign.plan, title: edition.title, copy: edition.copy,
		action: seasonal ? (surface === "landing" ? campaign.chooseFiles : campaign.sendYourOwn) : campaign.preview,
		note: typeof edition.note === "function" ? edition.note(monthlyPrice) : edition.note,
		caption: edition.caption, badge: edition.badge,
	};
}

/** Whether the plate quotes the monthly price, so the storefront is resolved only when it does. */
export function plateQuotesPrice(campaign: CampaignCopy, id: CampaignId): boolean {
	return typeof campaign.editions[id].note === "function";
}
